import React from "react";
import 'mdbreact/dist/css/mdb.css';
import { MDBCol, MDBContainer, MDBRow, MDBFooter } from "mdbreact";
import './footer.css';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <MDBFooter color="grey" className="font-small pt-4">
      <MDBContainer fluid className="text-center text-md-left">
        <MDBRow>
          <MDBCol className='mx-5' md="5">
            <h5 className="title">UAE Dentist</h5>
            <p>
                Find a dentist close to you.
            </p>
          </MDBCol>
          <MDBCol md="2">
            <h5 className="title">About our Service</h5>
            <ul>
              <li className="list-unstyled">
                <Link to="/about-us">About Us</Link>
              </li>

              <li className="list-unstyled">
                <Link to="/careers">Careers</Link>
              </li>
              <li className="list-unstyled">
                <Link to="/referrals">Referrals</Link>
              </li>
              <li className="list-unstyled">
                <Link to="/sitemap">Sitemap</Link>
              </li>
            </ul>
          </MDBCol>
          <MDBCol md="4">
            <h5 className="title">For Dentists</h5>
            <ul>
              <li className="list-unstyled">
                <Link to="/login">Log In</Link>
              </li>
              <li className="list-unstyled">
                <Link to="/register">Join Today</Link>
              </li>
              <li className="list-unstyled">
                <Link to="/for-dentists/super-practice">Super Practice</Link>
              </li>
              <li className="list-unstyled">
                <Link to="/for-dentists/patient-acquisition">Patient Acquisition</Link>
              </li>
            </ul>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
      <div className="footer-copyright text-center py-3">
        <MDBContainer fluid>
          &copy; {new Date().getFullYear()} Copyright: <a href="https://www.uae.dentist"> www.uae.dentist </a>
        </MDBContainer>
      </div>
    </MDBFooter>
  );
}

export default Footer;